import ClaimSessionTableRow from './ClaimSessionTableRow';

import type { Responsive, SelectableRows } from 'mui-datatables';
import type { IClientPolicyMap, ISessionWithClaimStatus } from '../../../../utils/types';

export const ClaimSessionTableOptions = (
  showSelectColumn: boolean,
  selectedProcedureCode: string,
  onSelectRow: (selected: boolean, data: ISessionWithClaimStatus) => void,
  historyClaimReviewDialogView: boolean,
  selectedPolicyDetails?: IClientPolicyMap,
) => ({
  filter: false,
  print: false,
  search: false,
  viewColumns: false,
  pagination: false,
  fixedHeader: false,
  sort: true,
  download: false,
  responsive: 'standard' satisfies Responsive,
  selectableRows: 'none' satisfies SelectableRows,
  tableBodyHeight: '100%',
  textLabels: {
    body: {
      noMatch: 'Attention: There are currently no entries for this time period',
    },
  },
  customRowRender: (data: any[]) => {
    const [
      selected,
      sessionStatus,
      date,
      id,
      provider_name,
      status,
      readonly,
      timeZone,
      procedureCode,
      isAwaitingFinalization,
      bay,
      licensed,
      credentialed,
      duration,
      isUnderClinicalReview,
      clinical_relationship,
      session_provider,
      author_id,
    ] = data;
    const session: ISessionWithClaimStatus = {
      selected,
      sessionStatus,
      id,
      provider_name,
      date,
      status,
      readonly,
      timeZone,
      procedureCode,
      isAwaitingFinalization,
      bay,
      licensed,
      credentialed,
      duration,
      isUnderClinicalReview,
      clinical_relationship,
      session_provider,
      author_id,
    };

    return (
      <ClaimSessionTableRow
        key={id}
        session={session}
        showSelectColumn={showSelectColumn}
        selectedProcedureCode={selectedProcedureCode}
        onSelectRow={onSelectRow}
        historyClaimReviewDialogView={historyClaimReviewDialogView}
        selectedPolicyDetails={selectedPolicyDetails}
      />
    );
  },
});
